__turbopack_context__.v({
  "blur-image": "style-module-scss-module__bOy6qG__blur-image",
  "component": "style-module-scss-module__bOy6qG__component",
  "date-added": "style-module-scss-module__bOy6qG__date-added",
  "date-added-mobile": "style-module-scss-module__bOy6qG__date-added-mobile",
  "favourite": "style-module-scss-module__bOy6qG__favourite",
  "image": "style-module-scss-module__bOy6qG__image",
  "price-time": "style-module-scss-module__bOy6qG__price-time",
  "right": "style-module-scss-module__bOy6qG__right",
  "street-address": "style-module-scss-module__bOy6qG__street-address",
  "text": "style-module-scss-module__bOy6qG__text",
  "wrapper": "style-module-scss-module__bOy6qG__wrapper",
});
